import React, { useState } from 'react';
import { Mail, Lock, LogIn } from 'lucide-react';
import logo from '../../resources/orca-logo.png'
import { useNavigate } from "react-router";

const OrcaLoginScreen = () => {
  let navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login process
    setTimeout(() => {
      setIsLoading(false);
      console.log('Login attempt with:', { email });
      // Add actual authentication logic here
      navigate("/analise");
    }, 1500);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br">
      {/* Animated background elements */}
      <div className="fixed top-0 left-0 w-full h-full overflow-hidden -z-10">
        <div className="absolute w-64 h-64 rounded-full bg-blue-200 opacity-20 -top-10 -left-10 animate-pulse"></div>
        <div className="absolute w-96 h-96 rounded-full bg-blue-300 opacity-10 bottom-10 -right-20 animate-pulse"></div>
        <div className="absolute w-48 h-48 rounded-full bg-indigo-200 opacity-20 bottom-20 left-20 animate-pulse"></div>
      </div>

      {/* Content container */}
      <div className="w-full max-w-md px-6 py-8 mx-4 bg-white rounded-xl shadow-xl backdrop-blur-sm bg-opacity-95 transition-all duration-300 hover:shadow-2xl">
        {/* Logo with animation */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-28 h-28 mb-3 transition-transform duration-500 hover:scale-110">
            <img src={logo} alt="Logo" />
          </div>
          <h2 className="text-4xl font-bold tracking-tight text-gray-800 drop-shadow-sm">ORCA</h2>
          <p className="mt-1 text-sm font-medium tracking-wider text-blue-600 uppercase">Optimized Responsive Clinical Analisys</p>
        </div>

        {/* Card effect for form */}
        <div className="p-6 bg-white rounded-lg border border-gray-100 shadow-sm">
          <h3 className="mb-6 text-xl font-semibold text-center text-gray-700">Entre na sua conta</h3>

          {/* Form */}
          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-700">
                E-mail
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400 group-focus-within:text-blue-500 transition-colors">
                  <Mail className="w-5 h-5" />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full py-3 pl-10 pr-3 text-gray-700 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 ease-in-out"
                  placeholder="nome@empresa.com"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-700">
                Senha
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400 group-focus-within:text-blue-500 transition-colors">
                  <Lock className="w-5 h-5" />
                </div>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full py-3 pl-10 pr-3 text-gray-700 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 ease-in-out"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={isLoading}
                className="relative flex items-center justify-center w-full px-5 py-3 text-base font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 border border-transparent rounded-lg shadow-sm hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 ease-in-out disabled:opacity-70"
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <svg className="w-5 h-5 mr-3 -ml-1 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Entrando...
                  </div>
                ) : (
                  <>
                    <LogIn className="w-5 h-5 mr-2" />
                    Entrar
                  </>
                )}
                
                {/* Button glow effect */}
                <span className="absolute inset-0 rounded-lg overflow-hidden">
                  <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-400 to-indigo-400 opacity-0 group-hover:opacity-10 transform transition-all duration-500"></span>
                </span>
              </button>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <div className="flex items-center justify-center mb-2">
            <div className="h-0.5 w-10 bg-gray-200"></div>
            <p className="mx-3 text-xs font-medium text-gray-500">LOGIN SEGURO</p>
            <div className="h-0.5 w-10 bg-gray-200"></div>
          </div>
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} ORCA. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrcaLoginScreen;